import { render, staticRenderFns } from "./ClickPopup.vue?vue&type=template&id=3bbfb5ea&scoped=true"
import script from "./ClickPopup.vue?vue&type=script&lang=js"
export * from "./ClickPopup.vue?vue&type=script&lang=js"
import style0 from "./ClickPopup.vue?vue&type=style&index=0&id=3bbfb5ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbfb5ea",
  null
  
)

export default component.exports